<template>
  <div class="how-active">
    <div class="ha-des">
      <p class="black">问：我按照引导激活课程，但提示“激活卡已激活”怎么回事？</p>
      <p>答：这种情况，应该是您早先已经将激活卡激活在其他手机号上了，请您回忆下您之前是在哪个手机号上激活的，然后点击我的——设置——退出登录，使用正确的手机号重新登录即可。</p>
      <!--<p>iOS用户：点击 <a href="https://www.kehigh.com/vip">https://www.kehigh.com/vip</a>，输入激活码激活即可。</p>
      <p>安卓用户：除了用上面方式激活，也可以如下图在App中点击头像，再选择“购买”，输入这20位数字，即可激活课程。</p>-->
    </div>
    <div class="ha-img">
      <img src="./img/login1.png" alt="">
    </div>
    <div class="ha-des">
       <p class="black">问：我的课程激活在他爸爸手机上了，但爸爸出差了，怎么办？？</p>
       <p>答：您可以用爸爸的手机号+验证码登录一次(验证码仍然需要爸爸发过来)，然后在可瀚学堂app，点击头像——设置——账号安全——修改密码，设置一个密码，下次再登录可瀚学堂APP时，就不需要验证码了，使用爸爸的手机号+密码。</p>
    </div>
    <div class="ha-img-02">
      <img src="./img/login2.png" alt="">
    </div>
    <div class="ha-des">
       <p class="black">问：手机号登录的话，手机不在身边怎么办？</p>
       <p>答：在可瀚学堂的新版本中，默认手机号密码登录，如果手机不在身边，不用过度担心，无需验证就可以使用账号密码直接登陆APP。</p>
    </div>
    <div class="ha-img-02">
      <img src="./img/login3.png" alt="">
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-active {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      padding-right: p2r(30);
      img {
        width: 100%;
      }
    }
    .ha-img-02 {
      img {
        width: 90%;
      }
      padding-right: p2r(30);
      text-align: right;
    }
  }
</style>
<script>
  export default{
    data(){
      return {
        msg: 'hello vue'
      }
    },
    created(){
      document.title = "其他问题? 可瀚学堂-深圳市格熙信息科技有限公司"
      this.$sendAnalytics('点击登录,激活等的相关问题')
    },
    components: {}
  }
</script>
